import { Divider } from "@mui/material";
import AlbumLayoutOrderSelector from "./AlbumLayoutOrderSelector";
import RefreshAlbumsButton from "./RefreshAlbumsButton";
import AlbumListFilters, { AlbumListFilterRowXS } from "./AlbumListFilters";
import { ShowingProvider as FiltersShowingProvider } from "../../../contexts/ShowingContext";

const AlbumListHeader = () => {
    return (
        <FiltersShowingProvider>
            <div className="d-flex flex-column px-1">
                <div className='full-width d-flex flex-row jc-space-between ai-center mb-0_5'>
                    <div>
                        <AlbumListFilters />
                    </div>
                    <div className="d-flex flex-row gap-0_5">
                        <RefreshAlbumsButton />
                        <AlbumLayoutOrderSelector />
                    </div>
                </div>
                <AlbumListFilterRowXS />
                <Divider />
            </div>
        </FiltersShowingProvider>
    )
}

export default AlbumListHeader;